const Auth = () => import("./Auth.vue");
const moduleRoute = {
    path: "/login",
    component:Auth
};
export default router=>{
    router.addRoutes([moduleRoute]);
}